import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

export type SessionInfo = {
  // the URL that launched the main application (e.g. http://localhost:4200/invenias/kyloedev)
  signInUrl: string;
};

/**
 * Stores information about the current session.
 */
@Injectable({ providedIn: 'root' })
export class SessionInfoStorage extends StorageService<SessionInfo> {
  constructor() {
    super('kp-sessioninfo');
  }
}
